import {
  Translate,
  ValidateCSVError,
  ValidateCSVFieldErrors,
  addErrorInLine,
  messages,
} from "../../../../../../components/Generic/UploadCSVFile/types";
import { InvoicesTemplateCSV, getInvoicesTemplateColumnName } from "../../utils";

export const validateCSVField = (
  dataItem: InvoicesTemplateCSV,
  line: number,
  lineErrors: ValidateCSVFieldErrors,
  translate: Translate
) => {
  const invoicesTemplateColumnName = getInvoicesTemplateColumnName(translate);

  let dataItemValid = true;

  const addError = (messageError: ValidateCSVError) => {
    addErrorInLine(lineErrors, line, translate(messageError), () => {
      dataItemValid = false;
    });
  };

  const message = messages(translate);

  return dataItemValid;
};

export const validateCSVFields = (
  data: InvoicesTemplateCSV[],
  lineErrors: ValidateCSVFieldErrors,
  translate: Translate
) => {
  const valids = new Array(data.length).fill(true, 0);

  data.forEach((dataItem, index) => {
    const line = index + 2;

    valids[index] = validateCSVField(dataItem, line, lineErrors, translate);
  });

  return {
    valid: valids.every((valid) => valid),
  };
};
